import {
    useBuscarHelper
  } from "../../../Commons/Scripts/Utils/webservice-helper.js"; 

const URL_BUSCAR_TARJETAS_DASHBOARD = "/Nomina/WebService/NominaWebService.asmx/BuscarDashboardTarjetas";
const URL_BUSCAR_GRAFICO_TOTAL_AUSENCIAS_DASHBOARD = "/Nomina/WebService/NominaWebService.asmx/BuscarGraficoTotalAusenciasDashboard";
const URL_BUSCAR_GRAFICO_TOTAL_PERMISOS_DASHBOARD = "/Nomina/WebService/NominaWebService.asmx/BuscarGraficoTotalPermisosDashboard";
const URL_BUSCAR_GRAFICO_TOTAL_LICENCIAS_DASHBOARD = "/Nomina/WebService/NominaWebService.asmx/BuscarGraficoTotalLicenciasDashboard";
const URL_BUSCAR_GRAFICO_TOTAL_PRESTAMOS_DASHBOARD = "/Nomina/WebService/NominaWebService.asmx/BuscarGraficoTotalPrestamosDashboard";
const URL_BUSCAR_GRAFICO_TOTAL_COSTO_HORAS_EXTRA_DASHBOARD = "/Nomina/WebService/NominaWebService.asmx/BuscarGraficoCostoHorasExtraDashboard";
const URL_BUSCAR_GRAFICO_TOTAL_TASA_HORAS_EXTRA_DASHBOARD = "/Nomina/WebService/NominaWebService.asmx/BuscarGraficoTasaHorasExtraDashboard";
const URL_BUSCAR_GRAFICO_TOTAL_HORAS_EXTRA_DASHBOARD = "/Nomina/WebService/NominaWebService.asmx/BuscarGraficoTotalHorasExtraDashboard";

const URL_BUSCAR_GRID_DEPARTAMENTOS_DASHBOARD = "/Nomina/WebService/DepartamentoWebService.asmx/BuscarDepartamentoRRHHGridDashboard";
const URL_BUSCAR_DEPARTAMENTOS_AUTOCOMPLETE = "/Nomina/WebService/DepartamentoWebService.asmx/BuscarListadoDepartamentos";

const URL_BUSCAR_GRID_EMPLEADOS_DASHBOARD = "/Nomina/WebService/EmpleadoWebService.asmx/BuscarEmpleadoRRHHGridDashboard";
const URL_BUSCAR_EMPLEADOS_AUTOCOMPLETE = "/Nomina/WebService/EmpleadoWebService.asmx/BuscarListadoEmpleados";

export const useObtenerGraficoTotalHorasExtraDashboard = (cuerpo) => {
  const url = URL_BUSCAR_GRAFICO_TOTAL_HORAS_EXTRA_DASHBOARD;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return {data, loading, error};   
}

export const useObtenerGridEmpleadosRRHHDashboard = (cuerpo) => {
    const url = URL_BUSCAR_GRID_EMPLEADOS_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }

  export const useBuscarEmpleadosAutoComplete = (cuerpo) => {
    const url = URL_BUSCAR_EMPLEADOS_AUTOCOMPLETE;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }


export const useObtenerGridDepartamentosRRHHDashboard = (cuerpo) => {
    const url = URL_BUSCAR_GRID_DEPARTAMENTOS_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }

  export const useBuscarDepartamentosAutoComplete = (cuerpo) => {
    const url = URL_BUSCAR_DEPARTAMENTOS_AUTOCOMPLETE;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }


export const useBuscarTarjetasDashboard = (cuerpo) => {
  const url = URL_BUSCAR_TARJETAS_DASHBOARD;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return {data, loading, error};   
}

export const useObtenerGraficoTotalAusenciasDashboard = (cuerpo) => {
    const url = URL_BUSCAR_GRAFICO_TOTAL_AUSENCIAS_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }

  export const useObtenerGraficoTotalPermisosDashboard = (cuerpo) => {
    const url = URL_BUSCAR_GRAFICO_TOTAL_PERMISOS_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }

  export const useObtenerGraficoTotalLicenciasDashboard = (cuerpo) => {
    const url = URL_BUSCAR_GRAFICO_TOTAL_LICENCIAS_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }

  export const useObtenerGraficoTotalPrestamosDashboard = (cuerpo) => {
    const url = URL_BUSCAR_GRAFICO_TOTAL_PRESTAMOS_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }

  export const useObtenerGraficoCostoHorasExtraDashboard = (cuerpo) => {
    const url = URL_BUSCAR_GRAFICO_TOTAL_COSTO_HORAS_EXTRA_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }

  export const useObtenerGraficoTasaHorasExtraDashboard = (cuerpo) => {
    const url = URL_BUSCAR_GRAFICO_TOTAL_TASA_HORAS_EXTRA_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }